import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStar = /*@__PURE__*/ proxyCustomElement(class CosmosIconStar extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a5bc9a2a8fee6badf0b3bc653f821bbc48a67c25', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e62d05f6d3161aa6ff953ca07111419d3eaed586', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '34cb78d23ac372dc37849836ff694fa7fdbdbd9a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.004 5.905 1.526 3.86 3.87.352-3.158 2.79 1.03 3.555-3.268-2.14-3.267 2.14 1.03-3.556-3.163-2.79 3.875-.351zm0-2.905c-.204 0-.346.151-.488.516L8.54 8.51l-4.892.445C3.187 9 3 9.116 3 9.364c0 .178.089.32.329.525l3.922 3.458-1.432 4.942c-.124.453-.017.711.294.711a.85.85 0 0 0 .426-.16l4.465-2.924 4.465 2.924a.9.9 0 0 0 .427.16c.32 0 .426-.267.293-.711l-1.432-4.942 3.914-3.458c.24-.205.329-.347.329-.525 0-.248-.187-.364-.649-.408l-4.883-.445-1.974-4.995c-.152-.374-.285-.516-.49-.516", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-star", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-star"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-star":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStar);
            }
            break;
    } });
}

export { CosmosIconStar as C, defineCustomElement as d };
